import React from 'react';
import { LockIcon, MoonIcon, ShieldCheckIcon, SparklesIcon, ZapIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { CtaButton } from './ui/CtaButton';
import { CHECKOUT_URL, PRICE, TOTAL_VALUE, PRODUCT } from '../data/content';
export function FinalCTA() {
  return <section aria-labelledby="cierre" className="border-y border-line bg-canvasAlt" data-id="element-82" data-mp="84nqkhcdb9po">
      <div className="mx-auto max-w-3xl px-4 sm:px-6 lg:px-8 py-14 text-center" data-id="element-83" data-mp="m46pqkn7bapu">
        <Reveal data-id="element-84" data-mp="h654pu67t1bq">
          <h2 id="cierre" className="font-display text-2xl md:text-4xl font-bold uppercase leading-[1.15] text-ink" data-id="element-85" data-mp="h6nabherorwb">
            Tu camino de regreso puede empezar hoy
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-sm md:text-base leading-relaxed text-ink-muted" data-id="element-86" data-mp="qwzu37erch1e">
            Podés seguir esperando a que llegue el momento perfecto. O podés
            empezar con unos minutos. Una pregunta. Una reflexión. Un pequeño
            límite. Un gesto de cuidado.
          </p>
          <p className="mx-auto mt-4 max-w-xl font-display text-lg md:text-xl font-bold leading-snug text-accent" data-id="element-87" data-mp="2c67sapgt7m91">
            Porque volver a ti no sucede de golpe. Sucede cada vez que decidís
            no dejarte para después.
          </p>
        </Reveal>

        <Reveal delay={0.05} className="mt-8 rounded-3xl border border-accent/25 bg-surface p-6 md:p-8" data-id="element-88" data-mp="2r2gqdnoyrtjv">
          <span className="inline-flex items-center gap-2 rounded-full bg-blush-soft px-4 py-1.5 text-xs font-bold uppercase tracking-[0.18em] text-blush" data-id="element-89" data-mp="2v2zgndb7krjy">
            <SparklesIcon size={14} data-id="element-90" data-mp="34sshpkdq5o9y" />
            Oferta activa
          </span>

          <p className="mt-4 flex items-center justify-center gap-2 font-display text-lg font-bold uppercase text-ink" data-id="element-91" data-mp="39sf52mn9okwh">
            <MoonIcon size={18} className="text-accent" data-id="element-92" data-mp="3es1hitv9tx48" />
            {PRODUCT}
          </p>
          <p className="mt-1 text-sm text-ink-muted" data-id="element-93" data-mp="3islg81vht8sh">4 tomos + 6 bonos</p>

          <p className="mt-4 text-xs font-bold uppercase tracking-[0.2em] text-ink-subtle" data-id="element-94" data-mp="3iqqrech3owj4">
            Valor total{' '}
            <span className="line-through decoration-danger" data-id="element-95" data-mp="1epie18o315au">
              {TOTAL_VALUE}
            </span>
          </p>
          <p className="mt-2 flex items-baseline justify-center gap-2" data-id="element-96" data-mp="1showx2imdqdz">
            <span className="font-display text-5xl font-bold text-accent" data-id="element-97" data-mp="1nq6vkdcopnsh">
              {PRICE}
            </span>
            <span className="text-lg font-semibold text-ink-muted" data-id="element-98" data-mp="22e1r01i2u699">ARS</span>
          </p>
          <p className="mt-1 text-xs font-bold uppercase tracking-[0.24em] text-blush" data-id="element-99" data-mp="1xg9o6cfw8zqa">
            Pago único
          </p>

          <CtaButton href={CHECKOUT_URL} external size="lg" className="mt-6" data-id="element-100" data-mp="2be7zta2tyi23">
            Quiero empezar hoy
          </CtaButton>

          <div className="mt-4 flex flex-wrap items-center justify-center gap-x-5 gap-y-2 text-xs text-ink-muted" data-id="element-101" data-mp="27btf0kflp886">
            <span className="flex items-center gap-1.5" data-id="element-102" data-mp="czwkujprxo9f">
              <LockIcon size={14} className="text-ink-subtle" data-id="element-103" data-mp="d1hfe9c3977a" />
              Pago seguro
            </span>
            <span className="flex items-center gap-1.5" data-id="element-104" data-mp="2whrcqyrgg2n">
              <ZapIcon size={14} className="text-gold" data-id="element-105" data-mp="6y35efn170ef" />
              Acceso digital inmediato
            </span>
            <span className="flex items-center gap-1.5" data-id="element-106" data-mp="3pahq5dlk5iy9">
              <ShieldCheckIcon size={14} className="text-success" data-id="element-107" data-mp="3uanm35yv1rm5" />
              Garantía 7 días
            </span>
          </div>
        </Reveal>
      </div>
    </section>;
}